import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade show d-block",
  "data-bs-backdrop": "static",
  tabindex: "-1",
  style: {"z-index":"9999"}
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-backdrop fade show",
  style: {"z-index":"9998"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (this.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("h5", _hoisted_5, _toDisplayString(this.title), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.cancel && this.cancel(...args)))
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "modal-body",
            innerHTML: this.body
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn", this.cancelButtonClass]),
              "data-bs-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (this.cancel && this.cancel(...args)))
            }, _toDisplayString(this.cancelButtonText), 3),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn", this.confirmButtonClass]),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (this.confirm && this.confirm(...args)))
            }, _toDisplayString(this.confirmButtonText), 3)
          ])
        ])
      ])
    ]),
    _hoisted_8
  ], 64))
}